import http from '../http'

export default {
    /**
     * Consulta el banco
     * @param {int} usuario
     * @returns {Promise}
     */
    get(usuario) {
        return http.get(`usuarios/${usuario}/bancos`)
    },

    /**
     * Crea el banco
     * @returns {Promise}
     */
    create(usuario, payload) {
        return http.post(`usuarios/${usuario}/bancos`, payload)
    },

    /**
     * Actualiza el banco
     * @param {int} usuario
     * @returns {Promise}
     */
    update(usuario, payload) {
        return http.put(`usuarios/${usuario}/bancos`, payload)
    },
}